import React from "react";
import { components, DropdownIndicatorProps } from "react-select";
import appConstants from "../config/app-constants";

const ValidCheckDropdownIndicator = (
  props: DropdownIndicatorProps<any, false>
) => {
  return (
    <components.DropdownIndicator {...props}>
      <img
        src={`${appConstants.webappBaseUrl}/icons/valid-check-icon.svg`}
        alt="select-check-icon"
      />
    </components.DropdownIndicator>
  );
};

export default ValidCheckDropdownIndicator;
